export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
            <div className="flex-1">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4">
                / À propos /
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-900 mb-6 leading-tight">
                Qu&apos;est-ce que Hipobuy Spreadsheet ?
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  <strong className="text-foreground-900 font-semibold">Hipobuy Spreadsheet</strong> est une solution moderne de gestion de données permettant d&apos;automatiser les feuilles de calcul, de structurer les informations et d&apos;améliorer la productivité de votre entreprise.
                </p>
                <p>
                  Conçue pour les professionnels du e-commerce, du marketing digital et de l&apos;analyse de données, cette plateforme offre une alternative puissante aux outils traditionnels comme Excel et Google Sheets.
                </p>
                <div className="grid grid-cols-2 gap-3 mt-6">
                  <div className="flex items-start gap-2">
                    <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-accent-600">
                      <i className="ri-checkbox-circle-fill"></i>
                    </span>
                    <span className="text-sm text-foreground-700">Automatisation des données</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-accent-600">
                      <i className="ri-checkbox-circle-fill"></i>
                    </span>
                    <span className="text-sm text-foreground-700">Analyse intelligente</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-accent-600">
                      <i className="ri-checkbox-circle-fill"></i>
                    </span>
                    <span className="text-sm text-foreground-700">Compatible workflows business</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-accent-600">
                      <i className="ri-checkbox-circle-fill"></i>
                    </span>
                    <span className="text-sm text-foreground-700">Alternative à Excel et Google Sheets</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1 flex justify-center">
              <div className="relative w-full max-w-md">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylish%20workspace%20with%20open%20laptop%20displaying%20colorful%20analytics%20charts%20beside%20a%20glass%20of%20iced%20latte%2C%20minimal%20desk%20with%20succulent%20plant%20and%20notebook%2C%20bright%20natural%20window%20light%2C%20warm%20oak%20wood%20tones%2C%20modern%20professional%20setting%2C%20editorial%20photography&width=720&height=720&seq=about-v2-showcase&orientation=squarish"
                  alt="Hipobuy Spreadsheet - Aperçu"
                  className="w-full rounded-xl object-cover"
                />
                <div className="absolute -bottom-4 -right-4 bg-primary-500 text-background-50 rounded-xl px-6 py-4 text-center">
                  <span className="font-heading font-bold text-3xl md:text-4xl block">14+</span>
                  <span className="text-xs opacity-80">catégories mode</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}